function classesToSelector(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!+\/])/g,"\\$1").replace(/ /g,".")}`}export{classesToSelector as c};
//# sourceMappingURL=classes-to-selector.mjs.map


//////////////////
// WEBPACK FOOTER
// ./~/swiper/shared/classes-to-selector.min.mjs
// module id = 631
// module chunks = 0